<template>
  <div class="modal-body-content" @click.stop="">
    <div class="modal-body-list-box">
      <div class="search-box-in-title">
        <h2>{{ $t(nowSelectedDepth.title) }} {{ $t('view_statistics') }}</h2>
      </div>
      <div style="width: 100%;" :style="getIsMobile() ? { padding: '0 5px' } : { padding: '0 48px' }">
        
        <AccessorS v-if="nowSelectedDepth?.key === 'AccessorS'"/>
        <EntryExitS v-if="nowSelectedDepth?.key === 'EntryExitS'"/>
        <WarnCountS v-if="nowSelectedDepth?.key === 'WarnCountS'"/>

      </div>
    </div>
  </div>
</template>

<script setup>
import { Chart, registerables } from "chart.js";
import { getIsMobile } from "@/utils/GlobalUtility";
import { nowSelectedDepth } from "@/utils/ModalUtility";
import AccessorS from "@/components/statistics/AccessorS.vue";
import EntryExitS from "@/components/statistics/EntryExitS.vue";
import WarnCountS from "@/components/statistics/WarnCountS.vue";
// import { nowSelectedDepth } from "@/utils/ModalUtility";

Chart.register(...registerables);

</script>